import styled, { css } from 'styled-components';

import Link from '../Link/Link';
import { CssClassName } from '../../../utils/generateCssClassName/types';

export const StyledInternalLink = styled(Link)<{
  showActiveState?: boolean
}>`
  &.${CssClassName.KIOSK} {
    display: none;
  }
  ${({ showActiveState }) => showActiveState && css`
    &.active {
      text-decoration: underline;
    }
  `}
`;

export const StyledExternalLink = styled.a`
  &.${CssClassName.KIOSK} {
    display: none;
  }
`;

export const StyledTextButton = styled.button`
  appearance: none;
  padding: 0;
  border: 0;
  outline: 0;
  text-decoration: underline;
  background-color: transparent;
  cursor: pointer;

  &.${CssClassName.KIOSK} {
    display: none;
  }
`;
